import { render, staticRenderFns } from "./PostBreadcrumbsMod.vue?vue&type=template&id=61ce32df"
import script from "./PostBreadcrumbsMod.vue?vue&type=script&lang=js"
export * from "./PostBreadcrumbsMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports